export default __webpack_public_path__ + "static/media/cp_geo_ms.c6877684.svg";